/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnregisterIBANInput
 */
export interface UnregisterIBANInput {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof UnregisterIBANInput
     */
    wallet: string;
}

/**
 * Check if a given object implements the UnregisterIBANInput interface.
 */
export function instanceOfUnregisterIBANInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "wallet" in value;

    return isInstance;
}

export function UnregisterIBANInputFromJSON(json: any): UnregisterIBANInput {
    return UnregisterIBANInputFromJSONTyped(json, false);
}

export function UnregisterIBANInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnregisterIBANInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'wallet': json['wallet'],
    };
}

export function UnregisterIBANInputToJSON(value?: UnregisterIBANInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'wallet': value.wallet,
    };
}

